import { useTranslation } from '../../../../contexts/translation-context';
import { formatDateTime } from '../../../../utils/date';
import { ComplaintAttachmentsList } from './ComplaintAttachmentsList';
import { DeleteOrderComplaintDialog } from './DeleteOrderComplaintDialog';
import { EditOrderComplaintDialog } from './EditOrderComplaintDialog';
import { LogOrderComplaintDialog } from './OrderComplaintDialog';
import { useOrder } from './orderContext';
import { EmptyState } from '../../../../components/empty-state/EmptyState';

export const OrderComplaintsPage = () => {
  const { order } = useOrder();
  const { i18n } = useTranslation();

  return (
    <div>
      <div className="mb-4 flex justify-end">
        <LogOrderComplaintDialog orderId={order.id} />
      </div>

      <div className="grid gap-4 xl:grid-cols-2">
        {order.complaints.map((complaint) => {
          return (
            <div className="card p-4" key={complaint.id}>
              <div className="mb-3">{complaint.content}</div>

              {/* Attachments section */}
              <ComplaintAttachmentsList complaintId={complaint.id} attachments={complaint.attachments || []} />

              <div className="flex justify-between items-center mt-3 pt-3 border-t border-border">
                <div className="text-sm text-fg-secondary">{formatDateTime(complaint.createdAt)}</div>
                <div className="flex items-center gap-2">
                  <div className="px-2 py-1 rounded-md inline-flex items-center bg-border-strong text-xs">
                    {i18n(`orderComplaintType.${complaint.type}`)}
                  </div>
                  <div className="flex items-center gap-1">
                    <div>
                      <EditOrderComplaintDialog complaint={complaint} />
                    </div>
                    <div>
                      <DeleteOrderComplaintDialog complaintId={complaint.id} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}

        {order.complaints.length === 0 && (
          <div className="col-span-full">
            <EmptyState
              title="Geen klachten gevonden"
              description="Gebruik de knop hierboven om een klacht toe te voegen"
            />
          </div>
        )}
      </div>
    </div>
  );
};
